module.exports = __webpack_public_path__ + "img/HA2510-83.bc0992ce.jpg";